import {createContext} from 'react';
import {FlyIcon, MoneyIcon, SerfIcon} from '../../../../../assets';
import {IInitialValues} from '../interfaces';

export enum TYPES {
  CERTIFICATES,
  DEPOSITS,
  SERVICES
}


export enum SIDEBAR_TYPES {
  MONEY,
  PIPE,
  WAVE,
  HYBRID
}
export const CERTIFICATES_TYPE: Record<string, any> = {
  [SIDEBAR_TYPES.HYBRID]:{
    id: 0
  },
  [SIDEBAR_TYPES.PIPE]:{
    id:1
  },
  [SIDEBAR_TYPES.WAVE]: {
    id: 2
  }
}




export const headerItems = [
  {
    id: TYPES.CERTIFICATES,
    label: 'Сертификаты'
  },
  {
    id: TYPES.DEPOSITS,
    label: 'Депозиты'
  },
  {
    id: TYPES.SERVICES,
    label: 'Услуги'
  }
]
export const sidebarItems = [
  {
    id: SIDEBAR_TYPES.MONEY,
    label: 'Деньги',
    icon: MoneyIcon,
    type: TYPES.DEPOSITS
  },
  {
    id: SIDEBAR_TYPES.PIPE,
    label: 'Аэротруба',
    icon: FlyIcon
  },
  {
    id: SIDEBAR_TYPES.WAVE,
    label: 'Волна',
    icon: SerfIcon
  },
  {
    id: SIDEBAR_TYPES.HYBRID,
    label: 'Гибридные',
    icon: SerfIcon
  }
]
export const initialValuesDepositsOrCertificate = (data: Record<string, any> | null, count: number,userId:number): IInitialValues => {
  return {
    discount: false,
    other: false,
    promo_code: null,
    is_pay_here: false,
    stock: undefined,
    base_price: data ? Math.trunc(data.price || data.default_price) : 0,
    price_stock: 0,
    payment_url: '',
    tariff_rate: {
      id: data ?  data.id : undefined ,
      price: data ? (Math.trunc(data.price) * count) : 0
},
    automatic_stock: false,
    manual_stock: null,
    customer: {value: userId},
    comment: '',
    certificate_party: ''
  }
}



// @ts-ignore
export const ContextDeposit = createContext();